module.exports = __webpack_public_path__ + "img/bg-yyzx.b32d3da2.png";